import React, { ReactNode, createContext, useContext } from 'react'

export interface FeatureFlags {
  enableTopicsDnd: boolean
}

const FeatureFlagsContext = createContext<FeatureFlags | null>(null)

interface FeatureFlagsProviderProps extends React.PropsWithChildren {
  flags: FeatureFlags | null
}

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({ flags, children }) => {
  return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>
}

export const useFeatureFlags = (): FeatureFlags | null => {
  const context = useContext(FeatureFlagsContext)

  return context
}

export const useFeatureFlag = <K extends keyof FeatureFlags>(key: K): FeatureFlags[K] | null => {
  const flags = useFeatureFlags()
  return flags?.[key] ?? null
}
